// extracted by mini-css-extract-plugin
export default {"btnpwd":"_07cd45326d"};